import { render, staticRenderFns } from "./KabNduga.vue?vue&type=template&id=4d33d629"
import script from "./KabNduga.vue?vue&type=script&lang=js"
export * from "./KabNduga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports